import { stringifySrcset } from "srcset";
import getMediaUrl from "@/utils/getMediaUrl";

const entries = [
  ["thumbnail", 245],
  ["small", 500],
  ["medium", 750],
  ["large", 1000],
  ["xlarge", 1400],
  ["xxlarge", 1920],
];

const getEntriesBasedOnMaximumSize = (file, maximumSize) => {
  if (!maximumSize) return [];

  if (typeof file === "string") return [];

  const _entries = entries.filter(([format]) => !!file?.formats?.[format]);
  if (!maximumSize) return _entries;

  const index = _entries.findIndex(([format]) => format === maximumSize);
  if (index === -1) return _entries;

  return _entries.slice(0, index + 1);
};

export default function generateSrcSet(file, maximumSize) {
  const _entries = getEntriesBasedOnMaximumSize(file, maximumSize);
  const withWidth = _entries.map(([format, width]) => ({
    url: getMediaUrl(file, format),
    width,
  }));

  return stringifySrcset(withWidth);
}
